/**
 * Condition Checklist List — boundary contract schemas (DC-12 / BR-34).
 *
 * Owned here, not beside the route: `apps/api/src/routes/manager/condition-checklist-list.routes.ts`
 * imports these to register the route, and `apps/landlord` derives its client types from them.
 *
 * Covers:
 *   GET /landlord/api/condition-checklists
 */
import { z } from 'zod';
import { WalkthroughPhaseSchema } from './walkthrough.js';
export const ChecklistStateSchema = z.enum(['NOT_STARTED', 'IN_PROGRESS', 'SUBMITTED']);
export const ChecklistLeaseStateSchema = z.enum(['current', 'historical']);
export const ChecklistListQuerySchema = z.object({
    leaseId: z.uuid().optional(),
    status: ChecklistStateSchema.optional(),
    phase: WalkthroughPhaseSchema.optional(),
    leaseState: ChecklistLeaseStateSchema.default('current'),
    q: z.string().max(100).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
// `submittedAt` is set only for a SUBMITTED/ACKNOWLEDGED side (never for a DRAFT, BR-17).
const ChecklistSideSchema = z.object({
    state: ChecklistStateSchema,
    walkthroughId: z.uuid().nullable(),
    submittedAt: z.string().nullable(),
});
export const ChecklistListItemSchema = z.object({
    leaseId: z.uuid(),
    unitId: z.uuid(),
    unitLabel: z.string(),
    propertyName: z.string(),
    leaseEndDate: z.string().nullable(),
    leaseState: ChecklistLeaseStateSchema,
    phase: WalkthroughPhaseSchema,
    landlord: ChecklistSideSchema,
    tenant: ChecklistSideSchema.extend({ optional: z.boolean() }),
});
export const ChecklistListResponseSchema = z.object({
    items: z.array(ChecklistListItemSchema),
    nextCursor: z.string().nullable(),
    /** True when the lease scan hit its cap, so some matching rows were not examined (BR-34). */
    truncated: z.boolean(),
});
//# sourceMappingURL=checklist-list.js.map